module.exports = __webpack_public_path__ + "static/media/unsupportedBrowserBackground.703ec897.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/unsupportedBrowserBackground.png
// module id = 1187
// module chunks = 0